import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneDropdownComponent = _resolveComponent("SceneDropdownComponent")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "contextMenu",
        class: "fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[160px] context-menu",
        style: _normalizeStyle(_ctx.menuStyle),
        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, [
        (!_ctx.isTrashedFolder && _ctx.hasAvailableScenes)
          ? (_openBlock(), _createBlock(_component_SceneDropdownComponent, {
              key: 0,
              folders: _ctx.folders,
              photo: _ctx.photo,
              onSceneSelected: _ctx.handleSceneSelected
            }, null, 8, ["folders", "photo", "onSceneSelected"]))
          : _createCommentVNode("", true),
        (!_ctx.isTrashedFolder && !_ctx.photo.is_cover)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMakeCover && _ctx.handleMakeCover(...args))),
              class: "w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('files.context_menu.make_cover')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTrashedFolder)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRecover && _ctx.handleRecover(...args))),
              class: "w-full px-4 py-2 text-left text-sm text-royal-blue-500 hover:bg-royal-blue-50 flex items-center gap-2"
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('files.context_menu.recover')), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isTrashedFolder)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args))),
              class: "w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('files.context_menu.delete')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isTrashedFolder)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args))),
              class: "w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('files.context_menu.delete')), 1)
            ]))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}